import React, { useState, useEffect } from "react";
import { Space, Row, Col, Tabs, Button, Spin, message } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import TabPane from "antd/lib/tabs/TabPane";
import "../../assets/dist/NewApplication/ApplicantPreview.css"
import { useHistory } from "react-router-dom";
import { routes } from "../../routes/Routes";
import AssessmentTab from "./AssessmentTab";
import SidebarLayout from "./SidebarLayout";
import ApplicationDetailsTab from "./ApplicationDetailsTab";
import FinancialStatementTab from "./FinancialStatementTab";
import LoanDetailsHeader from "./LoanDetailsHeader";
import ConcludeLoanRequest from "./ConcludeLoanRequest";
import _NewapplicationService from "../../modules/NewapplicationService";
import { COMMON_ERROR_MSG } from "../../constants/constants";
import "./LoanApplicationDetails.scss"

export default function LoanApplicationDetails() {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const location = useLocation();

  let data = location.state;
  let applicationObjId = "";
  let applicationId = "";
  let applicationStatusId = null;
  let emailId = '';

  if (data && data.email) {
    emailId = data.email;
  }

  if (data && data.applicationData && data.applicationData.Id) {
    applicationObjId = data.applicationData.Id;
  }

  if (data && data.applicationData && data.applicationData.ApplicationId) {
    applicationId = data.applicationData.ApplicationId;
  }

  if (data && data.applicationData && data.applicationData.Application_Status_Id) {
    applicationStatusId = data.applicationData.Application_Status_Id;
  }

  const [applnObjId] = useState(applicationObjId ? applicationObjId : localStorage.getItem("ApplicationObjId"));
  const [applnId] = useState(applicationId ? applicationId : localStorage.getItem("ApplicationId"));
  const [applnStatusId] = useState(applicationStatusId ? applicationStatusId : localStorage.getItem("ApplicationStatusId"));
  const [emailID] = useState(emailId ? emailId : localStorage.getItem("ApplicationEmailId"));
  const [applicantDetails, setApplicantDetails] = useState([]);
  const isLoanOfficer = JSON.parse(localStorage.getItem("IsLoanofficerFlag"));

  const [activeKey, setActiveKey] = useState("1");
  // Application Id now comes exclusively from navigation state (set by the page that linked
  // here), not from the URL — this closes the IDOR where a user could change /loanApplicationDetails/:Id
  // in the address bar to view another applicant's data. See the validity guard below.
  const ApplicationObjId = applicationObjId;
  const previewTabChange = (key) => {
    setActiveKey(key);
  }
  useEffect(() => {
  window.scrollTo(0, 0);
}, []);
  const goToMyApplications = () => {
    // history.push({ pathname: routes.myApplications.path });
    history.goBack()

  }

  useEffect(() => {
    const idNum = Number(ApplicationObjId);
    if (!ApplicationObjId || isNaN(idNum) || idNum <= 0) {
      history.replace(routes.homePage.path);
      return;
    }
    getApplicantDetailsByID(ApplicationObjId);
  }, []);

  const getApplicantDetailsByID = async () => {
    setLoading(true);
    try {
      const res = await _NewapplicationService.getApplicantInformationByApplicationId(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setApplicantDetails(resObj);
        setLoading(false);
      } else {
        message.error(COMMON_ERROR_MSG)
        setLoading(false);
      }
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  // Same fetch as getApplicantDetailsByID, but without the page-wide Spin overlay -- used to
  // refresh the "Loan Enquiry Amount" header (LoanDetailsHeader reads
  // applicantDetails.App_Det_LoanAmount_BankerAdjusted from this same state) right after a Senior
  // Private Banker/Underwriter Banker saves a Loan Amount adjustment in the Financial Statement
  // tab, so it updates immediately instead of only after navigating away and back.
  const refreshApplicantDetailsSilently = async () => {
    try {
      const res = await _NewapplicationService.getApplicantInformationByApplicationId(ApplicationObjId);
      if (res.data) {
        setApplicantDetails(res.data);
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <Spin spinning={loading}>
      <SidebarLayout>



        <Row justify="center" align="middle" className="backtoApplicationsROw"  >
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={24}
            xl={24}
            className="applicationbuttons mb10"
          >
            <Space direction="vertical" size={4}>
              <Button
                className="backtoApplicationsButtonDefault"
                type="text"
                icon={<LeftOutlined />}
                onClick={goToMyApplications}
              >
                Back to Applications
              </Button>
            </Space>
          </Col>
        </Row>

        <Col
          xs={24}
          sm={24}
          md={24}
          lg={24}
          xl={24}
          className="consumerDetailApplicationOverViewColumn"
        >
          <LoanDetailsHeader applicantDetails={applicantDetails} />
        </Col>

        <Row gutter={30} className="loan-application-details-tab">
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={24}
            xl={24}>
            <div className="card-section">
              <div className="applicationDetailcontainer  mr5">
                {/* --- Tabs Section --- */}
                <Tabs
                  className="custom-pill-tabs"
                  activeKey={activeKey}
                  onChange={previewTabChange}
                  tabBarExtraContent={
                    isLoanOfficer && (
                      <div style={{ paddingRight: 16 }}>
                        <strong>Banker Name:</strong>{" "}
                        {applicantDetails?.sponserModel?.BankerName}
                      </div>
                    )
                  }
                >
                  <TabPane tab={<span id="setAssessmentTab">Assessment</span>} key="1" />
                  <TabPane tab={<span id="setApplicationDetailsTab">Application Details</span>} key="2" />
                  <TabPane tab={<span id="setFinancialStatementTab">Financial Statement</span>} key="3" />
                </Tabs>
              </div>


              {/* --- Content Section --- */}
              <div>
                {activeKey === "1" && (
                  <AssessmentTab activeKey={activeKey} ApplicationObjId={ApplicationObjId} />
                )}

                {activeKey === "2" && (
                  <ApplicationDetailsTab activeKey={activeKey} ApplicationObjId={ApplicationObjId} />
                )}

                {activeKey === "3" && (
                  <FinancialStatementTab
                    activeKey={activeKey}
                    applicantDetails={applicantDetails}
                    ApplicationObjId={ApplicationObjId}
                    onLoanAmountAdjusted={refreshApplicantDetailsSilently}
                  />
                )}
              </div>
            </div>
            {/* <CBRScoreUpload applicantDetails={applicantDetails} /> */}
            <ConcludeLoanRequest activeKey={activeKey} applicantDetails={applicantDetails} ApplicationObjId={ApplicationObjId} />
          </Col>

        </Row>

      </SidebarLayout>
    </Spin>
  );
}